/* eslint-disable nordic/no-img-tags */
/* eslint-disable max-len */
const React = require('react');
const PropTypes = require('prop-types');
const Image = require('nordic/image');
const PluginCard = require('./PluginCard');
const PluginMainCard = require('./PluginMainCard');
const PluginsImagesSVG = require('./images');

function Plugins(props) {
  const { i18n, lang, platform, deviceType, setActiveItem, assetsPath } = props;
  const { siteId } = platform;
  const { PluginLojaIntegrada, PluginMagento, PluginNuvemShop, PluginPrestashop, PluginShopify, PluginVTEX, PluginWix, PluginWoocommerce } = PluginsImagesSVG;

  return (
    <div className="plugins-container">

      <div className="plugins-title">
        <h1 className="landings-h1">{i18n.gettext('Plugins y plataformas')}</h1>
        <p>{`${i18n.gettext('Instala nuestro checkout en tu sitio web y configura la experiencia de pago a tu manera')}. 
          ${deviceType === 'desktop'
          ? (`${i18n.gettext('También puedes cobrar con Mercado Pago con nuestras soluciones de e-commerce listas para usar en diferentes plataformas')}.`)
          : ''}`}
        </p>
      </div>

      {siteId === 'MLB' && (
        <PluginMainCard
          pluginLink="/official/shopify"
          image={<Image alt="shopify" src={`${assetsPath}images/PluginBannerShopify.png`} />}
          title={i18n.gettext('SHOPIFY')}
          text={i18n.gettext('Aumenta tu conversión con el nuevo Checkout API')}
          buttonText={i18n.gettext('Ver documentación')}
          setActiveItem={setActiveItem}
          platform={platform}
          lang={lang}
        />
      )}

      {siteId !== 'MLB' && (
        <PluginMainCard
          pluginLink="/woocommerce/introduction"
          image={<Image alt="woocommerce" src={`${assetsPath}images/PluginBannerWoocommerce.png`} />}
          title={i18n.gettext('WOOCOMMERCE')}
          text={i18n.gettext('Ofrece todos los medios de pago en tu tienda online')}
          buttonText={i18n.gettext('Ver documentación')}
          setActiveItem={setActiveItem}
          platform={platform}
          lang={lang}
        />
      )}

      <div className="plugins-title">
        <h2>{i18n.gettext('Plugin de Mercado Pago')}</h2>
      </div>

      <div className="plugins-secondary-cards">

        <PluginCard
          pluginLink="/woocommerce/introduction"
          image={<PluginWoocommerce />}
          title={i18n.gettext('WooCommerce')}
          text={i18n.gettext('Procesa pagos en tu sitio WordPress con nuestro checkout desarrollado para WooCommerce')}
          setActiveItem={setActiveItem}
          platform={platform}
          lang={lang}
        />

        <PluginCard
          pluginLink="/prestashop/introduction"
          image={<PluginPrestashop />}
          title={i18n.gettext('Prestashop')}
          text={i18n.gettext('Ofrece todos los medios de pago en Prestashop, una plataforma de comercio electrónico fácil de usar')}
          setActiveItem={setActiveItem}
          platform={platform}
          lang={lang}
        />

        <PluginCard
          pluginLink="/adobe-commerce/introduction"
          image={<PluginMagento />}
          title={i18n.gettext('Adobe Commerce')}
          text={i18n.gettext('Instala nuestro checkout en una plataforma con soluciones customizables para grandes empresas')}
          setActiveItem={setActiveItem}
          platform={platform}
          lang={lang}
        />

      </div>

      <div className="plugins-title">
        <h2>{i18n.gettext('Soluciones de e-commerce listas para usar')}</h2>
      </div>

      <div className="plugins-secondary-cards">

        <PluginCard
          pluginLink="/official/shopify"
          image={<PluginShopify />}
          title={i18n.gettext('Shopify')}
          text={i18n.gettext('Acepta todos los medios de pago y ofrece a tus clientes finalizar su compra desde nuestro sitio')}
          setActiveItem={setActiveItem}
          platform={platform}
          lang={lang}
        />

        <PluginCard
          pluginLink="/unofficial/lojaintegrada"
          image={<PluginLojaIntegrada />}
          title={i18n.gettext('Loja integrada')}
          text={i18n.gettext('Crea una tienda online gratis en solo cinco pasos y cobra a través de nuestros medios de pago')}
          setActiveItem={setActiveItem}
          platform={platform}
          lang={lang}
          visible={siteId.match(/^(MLB)$/)}
        />

        <PluginCard
          pluginLink="/unofficial/nuvemshop"
          image={<PluginNuvemShop />}
          title={i18n.gettext('Tiendanube')}
          text={i18n.gettext('Selecciona Mercado Pago como medio de pago para los clientes y aumenta las ventas del negocio')}
          setActiveItem={setActiveItem}
          platform={platform}
          lang={lang}
          visible={siteId.match(/^(MLB|MLA|MLM|MLC|MCO)$/)}
        />

        <PluginCard
          pluginLink="/unofficial/iset"
          image={<Image alt="iset" src={`${assetsPath}images/PluginISet.png`} />}
          title={i18n.gettext('iSET')}
          text={i18n.gettext('Usa la integración de Mercado Pago en iSET y procesa pagos basados en la nube')}
          setActiveItem={setActiveItem}
          platform={platform}
          lang={lang}
          visible={siteId.match(/^(MLB)$/)}
        />

        <PluginCard
          pluginLink="/unofficial/vtex/introduction"
          image={<PluginVTEX />}
          title={i18n.gettext('VTEX')}
          text={i18n.gettext('Gestiona tu negocio online con VTEX y procesa pagos con nuestra integración')}
          setActiveItem={setActiveItem}
          platform={platform}
          lang={lang}
        />

        <PluginCard
          pluginLink="/unofficial/linx"
          image={<Image alt="linx" src={`${assetsPath}images/PluginLinx.png`} />}
          title={i18n.gettext('Linx Commerce')}
          text={i18n.gettext('Integra Mercado Pago en una plataforma que potencia recursos y tecnología de e-commerce')}
          setActiveItem={setActiveItem}
          platform={platform}
          lang={lang}
          visible={siteId.match(/^(MLB)$/)}
        />

        <PluginCard
          pluginLink="/unofficial/wix"
          image={<PluginWix />}
          title={i18n.gettext('Wix')}
          text={i18n.gettext('Convierte tu sitio web en una tienda online con nuestra solución de pagos para WIX')}
          setActiveItem={setActiveItem}
          platform={platform}
          lang={lang}
        />

      </div>
    </div>
  );
}

Plugins.propTypes = {
  i18n: PropTypes.shape({
    gettext: PropTypes.func.isRequired,
  }),
  platform: PropTypes.shape({
    siteId: PropTypes.string,
    domain: PropTypes.string,
  }).isRequired,
  lang: PropTypes.string.isRequired,
  setActiveItem: PropTypes.func.isRequired,
  deviceType: PropTypes.func.isRequired,
};

Plugins.defaultProps = {
  i18n: { gettext: () => { } },
};

module.exports = Plugins;
